// ------ Actions ------

const SELECT_CAMPAIGNER_TYPE = "browseHero/SELECT_CAMPAIGNER_TYPE";
const SELECT_ALL_CAMPAIGNER_TYPES = "browseHero/SELECT_ALL_CAMPAIGNER_TYPES";

const SELECT_PERCENTAGE_RAISED = "browseHero/SELECT_PERCENTAGE_RAISED";
const SELECT_ALL_PERCENTAGES_RAISED = "browseHero/SELECT_ALL_PERCENTAGES_RAISED";

// ------ Reducer ------

const initialState = {
  selectedOwnerType: [],
  selectedPercentageRaised: [],
  selectedTags: [],
  availableTags: [],
};

const rootReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case SELECT_PERCENTAGE_RAISED:
      return {
        ...state,
        selectedPercentageRaised: [
          action.percentageRaised,
        ],
      };
    case SELECT_ALL_PERCENTAGES_RAISED:
      return {
        ...state,
        selectedPercentageRaised: [],
      };
    case SELECT_CAMPAIGNER_TYPE:
      return {
        ...state,
        selectedOwnerType: [
          action.ownerType,
        ],
      };
    case SELECT_ALL_CAMPAIGNER_TYPES:
      return {
        ...state,
        selectedOwnerType: [],
      };
    default: return state;
  }
};

export default rootReducer;

// ------ Synchronous Actions ------

export const selectOwnerType = (ownerType) => ({
  type: SELECT_CAMPAIGNER_TYPE,
  ownerType,
});

export const selectAllOwnerTypes = () => ({
  type: SELECT_ALL_CAMPAIGNER_TYPES,
});

export const selectPercentageRaised = (percentageRaised) => ({
  type: SELECT_PERCENTAGE_RAISED,
  percentageRaised,
});

export const selectAllPercentagesRaised = () => ({
  type: SELECT_ALL_PERCENTAGES_RAISED,
});
